export enum DetailsControlType {
  Input = 'input',
  Select = 'select',
  MultiSelect = 'multi-select',
  Textarea = 'textarea',
  Date = 'date',
  Combined = 'combined', // input + select
  Asset = 'asset',
  Template = 'template'
}
